import moment from "moment";
import React, { forwardRef } from "react";
import countries from "i18n-iso-countries";
import fr from "i18n-iso-countries/langs/fr.json";
import { Col, Row } from "react-bootstrap";
import { seatAddress } from "../../utils/regions";

countries.registerLocale(fr);

const PrintCreationProcedure = forwardRef(({ businessCreation }, ref) => {
  const servicesName = {
    registration: "Création de l'entreprise",
    domiciliation: "Domiciliation",
    management: "PlatformGest",
    admin: "PlatformAdmin",
    grh: "PlatformGRH",
    sales: "PlatformSale",
    juridique: "PlatformJuridique",
    name_registration: "Nom de l'entreprise",
    oapi: "OAPI",
    bank_account_registration: "Compte bancaire entreprise",
  };

  const steps = [
    "Vérifier les documents reçus",
    "Rédiger les status",
    "Rédiger la procuration",
    "Transmettre la procuration au client par Docusign",
    "Déposer le dossier au CFCE",
    "Récuper le RCCM au CFCE",
    "Enregistrer l'entreprise au centre des impôts et de rattachement",
    "Générer l'attestation de non redevance en ligne",
    "Immatriculer l'entreprise à la CNPS",
    "Téléverser les documents de l'entreprise",
    "Clôturer le ticket",
  ];

  return (
    <div
      ref={ref}
      style={{
        padding: "40px",
        fontSize: "14px",
        fontFamily: "Arial, sans-serif",
        color: "#333",
        lineHeight: "1.6",
        maxWidth: "800px",
        margin: "auto",
        backgroundColor: "#fff",
      }}
    >
      {/* HEADER */}
      <header style={{ textAlign: "center", marginBottom: "30px" }}>
        <img
          src="/images/logo-Cplatform.png"
          alt="Logo"
          width="200"
          height="50"
          style={{ marginBottom: "10px" }}
        />
        <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "#0056b3" }}>
          Démarche #{businessCreation.reference}
        </h2>
      </header>

      <Row
        style={{
          padding: "15px",
          borderBottom: "2px solid #ddd",
          marginBottom: "15px",
        }}
      >
        {/* INFORMATIONS DE LA DEMARCHE */}
        <Col>
          <h4
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            Informations de la démarche
          </h4>
          <p className="mb-1">Type : Création d'entreprise</p>
          <p className="mb-1">Référence : #{businessCreation.reference}</p>
          <p className="mb-1">
            Date : {moment(businessCreation.createdAt).format("DD/MMM/YYYY")}
          </p>
          {businessCreation.deadline && (
            <p className="mb-1">
              Délais de création :{" "}
              {(() => {
                const deadlines = {
                  WEEK: "Cette semaine",
                  DAYS: "Dans les jours à venir",
                  MONTHS: "Dans les mois à venir",
                };

                return deadlines[businessCreation.deadline] || "";
              })()}
            </p>
          )}
        </Col>

        {/* INFORMATIONS CLIENT */}
        <Col>
          <h4
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            Informations du client
          </h4>
          <p className="mb-1">
            Nom : {businessCreation.user?.firstname}{" "}
            {businessCreation.user?.lastname}
          </p>
          <p className="mb-1">Email : {businessCreation.user?.email}</p>
          <p className="mb-1">
            Téléphone : {businessCreation.user?.phone?.mobile}
          </p>
          {businessCreation.user?.phone?.whatsApp && (
            <p className="mb-1">
              WhatsApp : {businessCreation.user?.phone?.whatsApp}
            </p>
          )}
          <p className="mb-1">
            Pays de résidence :{" "}
            {countries.getName(businessCreation.user.country, "fr") ||
              businessCreation.user.country}
          </p>
        </Col>
      </Row>

      <Row
        style={{
          padding: "15px",
          borderBottom: "2px solid #ddd",
          marginBottom: "15px",
        }}
      >
        {/* INFORMATIONS ENTREPRISE */}
        <Col>
          <h4
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            Informations de l'entreprise
          </h4>
          <p className="mb-1">
            Type d'entreprise: {businessCreation.businessType}
          </p>
          <p className="mb-1">
            Nom l'entreprise:{" "}
            {businessCreation.businessName || "À fournir par Platform98"}
          </p>
          <p className="mb-1">
            Secteur d'activité :{" "}
            {(() => {
              const activitySectors = {
                COM: "Commerce général",
                BTP: "BTP",
                INF: "Services informatique",
                RES: "Restauration",
                IMM: "Activités immobilières (SCI)",
                VTC: "Transport VTC",
                ARG: "Agence de transfert d’argent",
                VOY: "Agence de voyage",
                ENT: "Services aux entreprises",
                FRE: "Consultation & Freelance",
                CAB: "Cabinet de conseil",
                AUT: "Autre",
              };

              return (
                activitySectors[businessCreation.activitySector] || "Inconnu"
              );
            })()}
          </p>
          <p className="mb-1">
            Gérant de l'entreprise : {businessCreation.managerName}
          </p>
          <p className="mb-1">
            Pays :
            {countries.getName(businessCreation.country, "fr") ||
              businessCreation.country}
          </p>
          {businessCreation.address && (
            <p className="mb-1">
              Siège social : {seatAddress(businessCreation)}
            </p>
          )}
          {businessCreation.bank && (
            <p className="mb-1">Banque : {businessCreation.bank}</p>
          )}
        </Col>

        {/* SERVICES ASSOCIÉS */}
        {businessCreation.services.filter(
          (service) => service.code !== "registration"
        ).length > 0 && (
          <Col>
            <h4
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              Services associés
            </h4>
            <ul style={{ paddingLeft: "20px" }}>
              {businessCreation.services
                .filter((service) => service.code !== "registration")
                .map((service, index) => {
                  const name = servicesName[service.code];

                  return (
                    <li key={index} style={{ marginBottom: "5px" }}>
                      {name}{" "}
                      {service.billing === "lifetime"
                        ? ""
                        : service.billing === "monthly"
                        ? " - Abonnement mensuel"
                        : service.billing === "yearly" &&
                          " - Abonnement annuel"}
                    </li>
                  );
                })}
            </ul>
          </Col>
        )}
      </Row>

      {/* ÉTAPES À SUIVRE */}
      <section
        style={{
          padding: "15px",
          marginBottom: "15px",
        }}
      >
        <h4
          style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "10px" }}
        >
          Étapes à suivre
        </h4>
        <ul style={{ paddingLeft: "20px", listStyleType: "none" }}>
          {steps.map((step, index) => (
            <li
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <input
                type="checkbox"
                style={{
                  marginRight: "10px",
                  width: "16px",
                  height: "16px",
                  cursor: "pointer",
                }}
              />
              {step}
            </li>
          ))}
        </ul>
      </section>

      {/* FOOTER */}
      <footer
        style={{
          textAlign: "center",
          marginTop: "30px",
          paddingTop: "10px",
          borderTop: "2px solid #ddd",
        }}
      >
        <p style={{ fontSize: "12px", color: "#777" }}>
          &copy; {new Date().getFullYear()} Platform98. Tous droits réservés.
        </p>
      </footer>
    </div>
  );
});

export default PrintCreationProcedure;
